'use client';

import { c as _c } from "react/compiler-runtime";
import Script from 'next/script';
import { supportsSpeculationRules } from './supportsSpeculationRules';
type SpeculationRulesScriptProps = {
  id: string;
  rules: Record<string, unknown>;
};

/**
 * Renders a browser Speculation Rules script (https://developer.chrome.com/docs/web-platform/prerender-pages)
 * for prefetching/prerendering a likely navigation, especially external apps.
 * Renders nothing on browsers that don't support the API (checked via `supportsSpeculationRules()`).
 */
export function SpeculationRulesScript(t0) {
  const $ = _c(5);
  const {
    id,
    rules
  } = t0;
  if (!supportsSpeculationRules()) {
    return null;
  }
  let t1;
  if ($[0] !== rules) {
    t1 = JSON.stringify(rules);
    $[0] = rules;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== id || $[3] !== t1) {
    t2 = <Script id={id} type="speculationrules">{t1}</Script>;
    $[2] = id;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}